import { axios } from '@/lib/axios';

export type ChapterQuizRebuildScope = 'CORE' | 'SCIENCE_EDUCATION' | 'LAB_MANUAL' | 'BUSINESS' | 'ALL';
export type ChapterQuizRebuildMode = 'ADD_MISSING' | 'REBUILD_ALL';

export type RebuildChapterQuizLibraryV2Data = {
    scope: ChapterQuizRebuildScope[];
    mode: ChapterQuizRebuildMode;
    locale: string;
};

export const rebuildChapterQuizLibraryV2 = (data: RebuildChapterQuizLibraryV2Data): Promise<void> =>
    axios.post('/api/admin/quiz/v2/library/rebuild', data);

export const rebuildChapterQuizByIdV2 = (uuid: string): Promise<void> =>
    axios.post(`/api/admin/quiz/v2/library/${uuid}/rebuild`);
